import { BasicEntity } from "../../core/models/basic-entity";

export class SubjugationCategory extends BasicEntity {
   
    constructor(entity?: Partial<SubjugationCategory>) {
        super(entity);
        Object.assign(this, entity);
    }
}
